import styled from "@emotion/styled";
import { useBloc } from "@blac/react";
import type { FC } from "react";
import { useCallback } from "react";
import translate from "src/lib/translate";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import useEscapeKey from "src/ui/hooks/useEscapeKey";
import WeightReadings from "../WeightReadings/WeightReadings";
import WeightReadingsBloc from "../WeightReadings/WeightReadingsBloc";
import { AppQueryPopupsController } from "../AppQueryPopups/AppQueryPopupsBloc";
import { getStreakMode } from "../WeightReadings/streakConfig";

const DIALOG_WIDTH = "min(calc(100vw - 2rem), 36.75rem)";
const DAILY_DESKTOP_HEIGHT = "min(calc(100vh - 2rem), 62.5rem)";

const WEEKLY_DESKTOP_HEIGHT = "min(calc(100vh - 4rem), 31.5rem)";
const WEEKLY_DESKTOP_HEIGHT_STRIKE = "min(calc(100vh - 2rem), 36.5rem)";

const ContentPadding = styled.div`
  padding: 2rem 1.5rem 1.5rem;
`;

const WeightReadingsDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();
  const [state, { completedWeek }] = useBloc(WeightReadingsBloc);
  const isWeekly = getStreakMode() === "weekly";
  const hasReachedStreak = isWeekly
    ? state.weeklyStreakCount > 3
    : completedWeek;
  const title = isWeekly
    ? translate("weeklyStreak.popup.title")
    : translate("dailyReadings.title");

  const onClose = useCallback(() => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  }, [navigate, returnUrl]);

  useEscapeKey(onClose);

  return (
    <InDialog
      popup
      title={title}
      returnUrl={returnUrl}
      onClose={onClose}
      backdropDismiss={false}
      padding="none"
      width={DIALOG_WIDTH}
      height={
        isWeekly
          ? hasReachedStreak
            ? WEEKLY_DESKTOP_HEIGHT_STRIKE
            : WEEKLY_DESKTOP_HEIGHT
          : DAILY_DESKTOP_HEIGHT
      }
    >
      <ContentPadding>
        <WeightReadings />
      </ContentPadding>
    </InDialog>
  );
};

export default WeightReadingsDialog;
